import {
  CUSTOMERS_GET_REQUEST,
  CUSTOMERS_GET_SUCCESS,
  CUSTOMERS_GET_ERROR,
  CUSTOMER_GET_REQUEST,
  CUSTOMER_GET_SUCCESS,
  CUSTOMER_GET_ERROR,
} from "store/actions";

export function customersApiReducer(state, action) {
  switch (action.type) {
    case CUSTOMERS_GET_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CUSTOMERS_GET_SUCCESS: {
      const { customers } = action.payload;
      return {
        ...state,
        customers,
        loading: false,
      };
    }
    case CUSTOMERS_GET_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case CUSTOMER_GET_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CUSTOMER_GET_SUCCESS: {
      const { customer } = action.payload;
      return {
        ...state,
        customers: state.customers.map((c) => (c.id === customer.id ? customer : c)),
        loading: false,
      };
    }
    case CUSTOMER_GET_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
}
export default customersApiReducer;
